// Small presentational pieces for the Country Adventure modal.
import { styles } from './styles';

export function SpeakerIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 9v6h4l5 4V5L8 9H4Z" />
      <path d="M16 9.5c1.2 1.4 1.2 3.6 0 5" />
      <path d="M18.5 7c2.5 2.8 2.5 7.2 0 10" />
    </svg>
  );
}

export function PauseIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M7 5h4v14H7V5Zm6 0h4v14h-4V5Z" />
    </svg>
  );
}

export function ChevronIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}

export function ProgressDots({ current, total = 5, color }) {
  return (
    <div style={styles.progressDots} aria-label={`Step ${current} of ${total}`}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          style={{
            ...styles.progressDot,
            background: i < current ? color : 'rgba(15,23,42,0.12)',
            transform: i + 1 === current ? 'scale(1.35)' : 'scale(1)',
          }}
        />
      ))}
    </div>
  );
}
